var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "videoPlayer"
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "videoInfo"
  }, [(_vm.courseDetails.contentId != undefined && _vm.courseDetails.contentId.length != 0) ? _c('div', {
    staticClass: "videoData"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.courseDetails.title != undefined && _vm.courseDetails.title != null) ? _c('h1', [_vm._v(_vm._s(_vm.courseDetails.title))]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', [(_vm.courseDetails.contentId != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != null && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId)) ? _c('div', [_c('div', {
    staticClass: "row justify-content-between"
  }, [(_vm.$store.getters.getItemPurchasedDates({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }).expiryDate != undefined && _vm.$store.getters.getItemPurchasedDates({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }).expiryDate != null) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$store.getters.getItemPurchasedDates({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }).expiryDate.split("/").join("-")))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Your course expires on")])]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.courseDetails.description != undefined && _vm.courseDetails.description != null) ? _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(" " + _vm._s(_vm.courseDetails.description))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center course-details-row align-items-center justify-content-center"
  }, [(_vm.courseDetails.enrolledCount != undefined && _vm.courseDetails.enrolledCount != null) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.courseDetails.enrolledCount))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Students enrolled")])]) : _vm._e(), _vm._v(" "), (_vm.courseDetails.skills != undefined && _vm.courseDetails.skills != null && _vm.courseDetails.skills.length > 0) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('h5', [_vm._v(_vm._s(_vm.courseDetails.skills.join(',')))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text text-center"
  }, [_vm._v("Skill Level")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 rating-star"
  }, [(_vm.isLoggedIn && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }) != undefined && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }) != null && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  })) ? _c('div', [_c('div', {
    on: {
      "click": function($event) {
        _vm.showRating(_vm.courseDetails.contentId)
      }
    }
  }, [_c('star-rating', {
    attrs: {
      "rating": _vm.courseDetails.rating,
      "increment": 0.5,
      "max-rating": 5,
      "inactive-color": "#96999a",
      "active-color": "#ffc000",
      "star-size": 22
    },
    on: {
      "rating-selected": _vm.setRating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.labels.your_Rating')))])]) : _c('div', [_c('star-rating', {
    attrs: {
      "rating": _vm.courseDetails.rating,
      "read-only": true,
      "increment": 0.5,
      "max-rating": 5,
      "inactive-color": "#96999a",
      "active-color": "#ffc000",
      "star-size": 15
    },
    on: {
      "rating-selected": _vm.setRating
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-text"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))])], 1)]), _vm._v(" "), (_vm.courseDetails.totalNumberofLO != undefined && _vm.courseDetails.totalNumberofLO != null && _vm.courseDetails.totalNumberofLO != 0) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.courseDetails.totalNumberofLO))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Lectures")])]) : _vm._e(), _vm._v(" "), (_vm.courseDetails.duration != undefined && _vm.courseDetails.duration != null && _vm.courseDetails.duration != 0) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.courseDetails.duration + 'H') + " ")]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Course duration")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [(_vm.courseDetails.languageId != undefined && _vm.displayLanguage(_vm.courseDetails.languageId) != undefined && _vm.displayLanguage(_vm.courseDetails.languageId) != null) ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.displayLanguage(_vm.courseDetails.languageId)))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Available in")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), (_vm.courseDetails.contentId != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != null && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId)) ? _c('div', [_c('div', {
    staticClass: "col-auto"
  }, [(_vm.courseDetails.contentId != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != null && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId)) ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.courseDetails.price) + " " + _vm._s(_vm.courseDetails.price > 1 ? 'Point' : 'Points'))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Course costs")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.isLoggedIn) ? _c('div', [(_vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }) != undefined && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }) != null && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  })) ? _c('div', {
    staticClass: "pb-3"
  }, [_c('button', {
    staticClass: "btn btn-blue-no-bg btn-blk",
    on: {
      "click": function($event) {
        _vm.goToCourse(_vm.courseDetails)
      }
    }
  }, [_vm._v("GO TO COURSE")])]) : (_vm.featureStatusInfoList && _vm.featureStatusInfoList.cart) ? _c('div', {
    staticClass: "pb-3"
  }, [(_vm.$store.getters.itemPresentInCartStatus(_vm.courseDetails.contentId)) ? _c('button', {
    staticClass: "btn btn-blue-no-bg btn-blk"
  }, [_vm._v("ADDED TO CART")]) : _c('button', {
    staticClass: "btn btn-blk btn-blue",
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.courseDetails.contentId)
      }
    }
  }, [_vm._v("ADD TO CART")])]) : _vm._e()]) : (_vm.featureStatusInfoList && _vm.featureStatusInfoList.cart) ? _c('div', [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Price")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.courseDetails.price) + " " + _vm._s(_vm.courseDetails.price > 1 ? 'Point' : 'Points'))]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blk btn-blue",
    on: {
      "click": function($event) {
        _vm.goToLogin()
      }
    }
  }, [_vm._v("ADD TO CART")])])]) : _vm._e()])])]) : _c('div', {
    staticClass: "noticemsg"
  }, [_vm._v("\n        SOMETHING WENT WRONG\n      ")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44cc9118","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/bannerVideo.vue
// module id = 8Fcd
// module chunks = 1